import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import StockService from 'Service/stock';
import Info from 'Container/stock/info';
import Qais from 'Container/stock/qais';
import Season from 'Container/stock/season';
import RelativeRate from 'Container/stock/relative_rate';
import Investor from 'Container/stock/investor';
import Outline from 'Container/stock/outline';
import { Helmet } from 'react-helmet-async';
import GuideStock from 'Component/guide/stock';
import ComplianceNote from 'Component/stock/compliance_note';
import FinancialStatements from 'Container/stock/financial_statements';
import EmptyStock from 'Component/empty_stock';

const AIFocus = () => {
  const { tickerDetail, ticker, hasLoadedTicker } = useSelector((state) => state.stock);

  const [showEmpty, setShowEmpty] = useState(false);

  useEffect(() => {
    let t;
    if (ticker && hasLoadedTicker && tickerDetail === null) {
      t = setTimeout(() => setShowEmpty(true), 300);
    } else {
      setShowEmpty(false);
    }
    return () => clearTimeout(t);
  }, [tickerDetail, ticker, hasLoadedTicker]);

  return (
    <>
      <Helmet>
        <title>MTN AI Focus</title>
      </Helmet>
      <div id="stock">
        <div className="container">
          <StockService />
          { tickerDetail && Number(tickerDetail.STK_TYP) === 1 && (
            <>
              <Info />
              <Qais />
              <Season />
              <RelativeRate />
              <FinancialStatements />
              <Investor />
              <Outline />
              <ComplianceNote />
            </>
          )}
          { tickerDetail && Number(tickerDetail.STK_TYP) === 2 && (
            <>
              <Info />
              <Season />
              <Outline />
              <ComplianceNote />
            </>
          )}
          { showEmpty && <EmptyStock /> }
          <GuideStock />
        </div>
      </div>
    </>
  )
}

export default AIFocus;
